import { createFileRoute } from "@tanstack/react-router";
import { AdminTicketsPage } from "@/components/admin/pages/AdminTicketsPage";

export const Route = createFileRoute("/pulse-ops-x7k2/tickets")({
  component: AdminTicketsPage,
});
